const DEFAULT_LOCATIONS = [{ country: 'Россия' }, { country: 'Беларусь' }]
const EMPTY_VALUE = ''

export async function fetchCitySuggestions({ query, token, locations = DEFAULT_LOCATIONS }) {
  const safeQuery = String(query || '').trim()
  const safeToken = String(token || '').trim()

  if (!safeQuery) return []

  if (!safeToken) {
    console.error('Dadata token is empty')
    return []
  }

  const response = await fetch('https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Token ${safeToken}`,
    },
    body: JSON.stringify({
      locations,
      query: safeQuery,
      from_bound: { value: 'city' },
      to_bound: { value: 'city' },
    }),
  })

  const data = await response.json()

  if (!Array.isArray(data.suggestions)) {
    return []
  }

  return data.suggestions.map(mapCitySuggestion)
}

export async function fetchOrganisationSuggestions({ query, token, location = null, count = 20 }) {
  const safeQuery = String(query || '').trim()
  const safeToken = String(token || '').trim()

  if (!safeQuery) return []

  if (!safeToken) {
    console.error('Dadata token is empty')
    return []
  }

  const country = getLocationCountry(location)
  const isBelarus = country.toLowerCase() === 'беларусь'

  const url = `https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party${isBelarus ? '_by' : ''}`

  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Token ${safeToken}`,
    },
    body: JSON.stringify({
      query: safeQuery,
      count,
    }),
  })

  const data = await response.json()

  if (!Array.isArray(data.suggestions)) return []

  return data.suggestions.map(suggestion => mapOrganisationSuggestion(suggestion, location))
}

function mapCitySuggestion(suggestion) {
  const data = suggestion.data || {}

  return {
    country: data.country || EMPTY_VALUE,
    city: data.city || data.settlement || EMPTY_VALUE,
    district: data.federal_district || EMPTY_VALUE,
    region_with_type: data.region_with_type || EMPTY_VALUE,
    region: data.region || EMPTY_VALUE,
    index: data.postal_code || EMPTY_VALUE,
    value: suggestion.value || EMPTY_VALUE,
    unrestricted_value: suggestion.unrestricted_value || EMPTY_VALUE,
  }
}

function getLocationCountry(location) {
  return String(location?.country || '').trim()
}

function mapOrganisationSuggestion(suggestion, location) {
  const data = suggestion.data || {}
  const addressData = data.address?.data || {}

  return {
    name: data.fio_ru || data.full_name_ru || data.name?.short || data.name?.full || EMPTY_VALUE,
    opf: data.opf?.short || EMPTY_VALUE,
    inn: data.unp || data.inn || EMPTY_VALUE,
    kpp: data.kpp || EMPTY_VALUE,
    address: data.address?.value || data.address || EMPTY_VALUE,

    country: addressData.country || location?.country || EMPTY_VALUE,
    city: addressData.city || location?.city || EMPTY_VALUE,
    index: addressData.postal_code || location?.index || EMPTY_VALUE,
    region_with_type: addressData.region_with_type || location?.region_with_type || location?.region || EMPTY_VALUE,
    region: addressData.region || location?.region || EMPTY_VALUE,
  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/services/dadata/dadata.service.js